$.fn.currency = function (options) {

    // const settings = $.extend({
    //     serviceUrl: "/currency.php"
    // }, options);
    //
    // const request = $.ajax({
    //     url: settings.serviceUrl,
    //     dataType: "json"
    // });

    return this.each(function () {
        const parent = $(this);

    //     request.done((response) => {
    //         parent.find('.html__items--content').empty();
    //         const rows = Object.keys(response).map((rowIndex, index) => {
    //             let _class = '';
    //             if (index > 0) {
    //                 _class = 'hide';
    //             }
    //             let row = response[rowIndex];
    //             console.log('response',response,row)
    //             let _icon = 'icon-arrow_drop_up';
    //             if (row[3] === 'down') {
    //                 _icon = 'icon-arrow_drop_down';
    //             }
    //             parent.find('select').append(`<option value="${rowIndex}">${row[0]}</option>`);
    //             parent.find('.html__items--content').append(`<div class="html__item ${_class}" data-id="${rowIndex}">
    //     <div class="html__item--index ${row[3]}"><i class="${_icon}"></i></div>
    //     <div class="html__item--value">${row[1]}</div>
    // </div>`);
    //             parent.find('.html__items--content').append(`<div class="html__item ${_class}" data-id="${rowIndex}">
    //             <div class="html__item--index ${row[3]}"><i class="${_icon}"></i></div>
    //             <div class="html__item--value">${parseFloat(row[1]) - 0.010}</div>
    // </div>`);
    //
    //         });
    //     });

        parent.find('select').change(function () {
            let _val = $(this).val();
            let _wrapper = parent.find('.html__items--content');
            _wrapper.find('.html__item').addClass('hide');
            _wrapper.find(`.html__item[data-id="${_val}"]`).removeClass('hide');
        });
    });

};

export default class Currency {
    constructor(selector, options = {}) {
        $(selector).currency(options)
    }
}
